const initialState = {
  user: null,
  users: [],

};

const authReducers = (state = initialState, action) => {
  switch (action.type) {
    case "SIGN_UP_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_ALL_USERS":
      return {
        ...state,
        users: action.payload,
      };
    default:
      return state;
  }
};

export default authReducers;
